<script>
  import LoteRestricaoService from '../../../../../domain/leiloes/services/lote-restricoes'
  import PopupViewer from '../../../../_default/components/popup-viewer/PopupViewer'

  export default {
    name: 'GerenciamentoLoteRestricoes',
    components: {
      PopupViewer,
      NovoLoteRestricao: () => import('./NovoLoteRestricao')
    },
    data () {
      return {
        restricoes: [],
        restricoesLoading: false,
        showRestricaoForm: false,
        restricaoSendoEditada: null
      }
    },
    created () {
      this.init()
    },
    mounted () {
      this.carregarRestricoesLote()
    },
    filters: {
      upper (str) {
        if (!str) {
          return ''
        }
        return str.toUpperCase()
      }
    },
    methods: {
      init () {
        this.$nextTick(() => {
          let tableRestricoesHead = this.$el.querySelector('#tableRestricoesHead')
          let tableRestricoesBody = this.$el.querySelector('#tableRestricoes')
          console.log(tableRestricoesBody.clientWidth, tableRestricoesHead.clientWidth)
          tableRestricoesHead.style.width = tableRestricoesBody.clientWidth + 'px'
        })
      },
      carregarRestricoesLote () {
        this.restricoesLoading = true
        LoteRestricaoService.getRestricoesLote(this.$route.params.id)
          .then(response => {
            this.restricoes = response.data
            this.restricoesLoading = false
          })
          .catch(error => {
            alert('Erro ao carregar as restricoes')
            alert(error.data.errors)
            console.log(error)
            this.restricoesLoading = false
          })
      },
      openRestricaoForm (evt, id = null) {
        this.restricaoSendoEditada = id
        this.showRestricaoForm = true
      },
      closeRestricaoForm () {
        this.carregarRestricoesLote()
        this.showRestricaoForm = false
        this.restricaoSendoEditada = null
      },
      deletarRestricaoLote (evt, id, index) {
        const {nome} = this.restricoes[index]
        if (!confirm(`Remover restrição "${nome}" deste lote?`)) {
          return
        }
        this.$loaderOverlay.open('Excluindo...')
        LoteRestricaoService.deleteRestricaoLote(this.$route.params.id, id)
          .then(response => {
            this.$loaderOverlay.hide()
            this.carregarRestricoesLote()
          })
          .catch(error => {
            console.log(error)
            alert('Ocorreu um erro ao tentar excluir esse debito')
            this.$loaderOverlay.hide()
          })
      }
    }
  }
</script>

<template>
    <div class="wrapper-sm no-padder m-b">
      <div class=" bg-black">
        <div class="wrapper-sm bg-dark font-bold text-uppercase">
          Restrições <u-button @click.prevent="openRestricaoForm" class="btn btn-info btn-xs pull-right m-b" ><i class="fa fa-plus"></i> CADASTRAR NOVA RESTRIÇÃO</u-button>
        </div>
        <div class="bg-black pos-rlt" id="tableRestricoesHead">
          <table class="table table-black bg-black m-b-none">
            <thead>
            <tr>
              <th style="width: 50%">Tipo de Restrição</th>
              <th style="width: 50%">Opções</th>
            </tr>
            </thead>
          </table>
        </div>
        <div class="scroll-black scroll-lote">
          <table class="table table-black" id="tableRestricoes" style="margin-top: -36px">
            <thead>
            <tr>
              <th style="width: 50%">Tipo de Restrição</th>
              <th style="width: 50%">Opções</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(restricao, index) in restricoes" v-if="!restricoesLoading">
              <td>
                <div>{{restricao.nome | upper}} <small class="text-danger" v-if="restricao.impeditiva">(impeditiva)</small></div>
              </td>
              <td>
                <u-button class="btn btn-xs btn-info pull-none-xs hidden-print  m-l-sm" tabindex="1"
                          @click.prevent="openRestricaoForm(null, restricao.id)">Editar
                </u-button>
                <u-button class="btn btn-xs btn-danger pull-none-xs hidden-print  m-l-sm" tabindex="1"
                          @click.prevent="deletarRestricaoLote(null, restricao.id, index)">Excluir
                </u-button>
              </td>
            </tr>
            <tr v-if="(restricoes && !restricoes.length) && !restricoesLoading">
              <td colspan="5" class="no-borders" style="border-bottom: none"><span class="text-danger">Nenhuma restrição encontrada</span>
              </td>
            </tr>
            <tr v-if="restricoesLoading">
              <td colspan="5" class="no-borders text-center" style="border-bottom: none"><i
                class="fa fa-spin fa-spinner m-t fa-2x"></i></td>
            </tr>
            </tbody>
          </table>
        </div>
    </div>
    <!--<a @click="openRestricaoForm" class="btn btn-info m-b">Cadastrar debito</a>-->
    <popup-viewer @close="closeRestricaoForm" v-if="showRestricaoForm" :title="`Edição de dados de Restrição`">
      <NovoLoteRestricao @finishSubmit="closeRestricaoForm" @cancel="closeRestricaoForm" :restricaoId="restricaoSendoEditada"/>
    </popup-viewer>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// GerenciamentoLoteRestricoes.vue?b49fdb08